module.exports = __webpack_public_path__ + "static/img/szafa_dso_42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_dso_42.svg
// module id = Fo4M
// module chunks = 0